import { H1, P } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import { useGetExerciseSubmissions } from '../../hooks/use-hydra/admin';
import SOSQuestions from '../../components/Admin/SOSQuestions';
import { ROUTES } from '../../routing';

day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'SOS Questions',
        url: null,
      },
    ]}
  />
);

export default function SOSQuestionsPage() {
  const { id } = useParams<{ id: string }>();
  const {
    data,
    isLoading: isCompanyLoading,
    error,
    refetch,
  } = useGetCompany(parseInt(id));
  const { data: submissionsData, isLoading: isSubmissionsLoading } =
    useGetExerciseSubmissions(parseInt(id));

  const headerText = `${data?.name} SOS Questions`;

  return (
    <PageWithAsyncData
      isLoading={isSubmissionsLoading || isCompanyLoading}
      error={error}
      retry={refetch}
      noScroll
    >
      <NavbarWithBreadcrumbs name={data?.name} companyId={id} />
      <CompanyPageWrapper
        shouldAddEmptyDiv={false}
        currentPage={COMPANY_PAGES.SUBMISSIONS}
        contentStyle={{ width: '100%', overflowX: 'auto', maxWidth: '100%' }}
      >
        <H1>{headerText}</H1>
        <P>Review learners' SOS requests across the learning program.</P>
        <SOSQuestions submissions={submissionsData?.submissions || []} />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
